import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  Typography,
  Divider
} from '@mui/material';
import {
  Settings as SettingsIcon,
  LightMode as LightModeIcon,
  DarkMode as DarkModeIcon,
  Brightness4 as Brightness4Icon,
  Language as LanguageIcon,
  Translate as TranslateIcon
} from '@mui/icons-material';
import { useTranslation } from '../utils/translations';

const Settings = ({ open, onClose, themeMode, onThemeModeChange, language, onLanguageChange }) => {
  const t = useTranslation(language);
  
  const handleThemeChange = (event) => {
    onThemeModeChange(event.target.value);
  };

  const handleLanguageChange = (event) => {
    onLanguageChange(event.target.value);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', pb: 1 }}>
        <SettingsIcon sx={{ mr: 1 }} />
        {t('settings')}
      </DialogTitle>
      
      <Divider />
      
      <DialogContent sx={{ pt: 3 }}>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            {t('appearance')}
          </Typography>
          
          <FormControl component="fieldset">
            <FormLabel component="legend" sx={{ mb: 1 }}>
              {t('themeMode')}
            </FormLabel>
            <RadioGroup
              value={themeMode}
              onChange={handleThemeChange}
              row
            >
              <FormControlLabel
                value="light"
                control={<Radio />}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <LightModeIcon sx={{ mr: 1, fontSize: 20 }} />
                    {t('light')}
                  </Box>
                }
              />
              <FormControlLabel
                value="dark"
                control={<Radio />}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <DarkModeIcon sx={{ mr: 1, fontSize: 20 }} />
                    {t('dark')}
                  </Box>
                }
              />

            </RadioGroup>
          </FormControl>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            {t('language')}
          </Typography>
          
          <FormControl component="fieldset">
            <FormLabel component="legend" sx={{ mb: 1 }}>
              {t('selectLanguage')}
            </FormLabel>
            <RadioGroup
              value={language}
              onChange={handleLanguageChange}
              row
            >
              <FormControlLabel
                value="english"
                control={<Radio />}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <LanguageIcon sx={{ mr: 1, fontSize: 20 }} />
                    {t('english')}
                  </Box>
                }
              />
              <FormControlLabel
                value="italian"
                control={<Radio />}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <TranslateIcon sx={{ mr: 1, fontSize: 20 }} />
                    {t('italian')}
                  </Box>
                }
              />
            </RadioGroup>
          </FormControl>
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Settings; 